module.exports = __webpack_public_path__ + "static/media/hanger.65df1062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hanger.png
// module id = 35
// module chunks = 0